<template>
  <li class="list_once">
    <p class="p">如何将印章授权给成员使用</p>
    <p class="text">1.在首页中点击“企业控制台”进入企业管理界面；</p>
    <img class="img" src="/images/home/sign_img16.png" alt="">
    <p class="text">2.点击“印章及授权”，进入企业印章页面，点击印章下“添加用印审批流程”按钮；</p>
    <img class="img" src="/images/home/sign_img17.png" alt="">
    <p class="text">3.选择需要关联的审批流程，点击确认。（为创建审批流程时，点击用印审批设置菜单入口即可去创建、管理用印审批流程）</p>
    <img class="img" src="/images/home/sign_img18.png" alt="">
  </li>
</template>
<script>
  export default {
    data () {
      // 这里存放数据
      return {}
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {},
  }
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
  .list_once {
    font-size: 14px;
    padding: 10px;
    .p {
      font-size: 16px;
      font-weight: bold;
    }
    .text {
      margin: 10px 0;
    }
    .img {
      max-width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// pages/dingtalkUse/helpCenterCom/6_menberUse.vue